<style lang="scss"></style>
<style lang="scss" scoped="scoped">
.gradient-text-one {
  background-image: -webkit-linear-gradient(#85fdff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#202027' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;border-bottom: 1px #636363 solid;padding: 10px;" :style="{ 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC' }">
      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
        <p class="gradient-text-one" style="font-size: 18px;font-weight: 600;line-height: 22px;">
          {{ $t("gongdanchanchufenxi") }}
        </p>
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <div id="manufaturingOutPutChart" style="flex:1;" :style="{ height: contentHeight + 'px' }"></div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "web_monitor_manufacturing_output",
  components: {},
  watch: {
    "$attrs.orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    },
  },
  data() {
    return {
      chart: null,
      option: null,
      timer: null,
      contentHeight: 0,
      lists: [],
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 300000);
    this.listData();
  },
  mounted() {
    console.log('$attrs',this.$attrs)
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get("/web/report/page/zhinengzhizao_gondanchanchufenxi?getOrgByParent=orgId", {
        params: {
          orderBy: "dateTimeStr asc",
          orgId: this.$attrs.orgId,
        },
      });
      this.lists = response.data.rows;

      if (!this.chart) {
        this.initChart();
      }

      let x = this.lists.map((item) => {
        return item.dateTimeStr.split("-")[1] + "-" + item.dateTimeStr.split("-")[2];
      });
      let y = this.lists.map((item) => {
        return item.v;
      });

      this.option.xAxis.data = x;
      this.option.series[0].data = y;
      this.chart.setOption(this.option);
      this.resize();
    },

    initChart() {
      this.option = {
        backgroundColor: null,
        legend: {
          left: "center",
          top: "0%",
          textStyle: {
            color: "#FFFFFF",
            fontSize: 12,
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "14",
          right: "14",
          bottom: "14",
          top: "20",
          containLabel: true,
        },

        xAxis: {
          show: true,
          type: "category",
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: "#C0C4CC",
            },
            interval: "auto",
          },
          axisTick: {
            show: false,
          },
          data: [],
        },
        yAxis: [
          {
            show: true,
            type: "value",
            min: 0,

            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                fontSize: 12,
                color: "#C0C4CC",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#606672",
              },
            },
          },
        ],
        series: [
          {
            name: this.$t("chanliang"),
            type: "bar",
            barWidth: "8px",
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#6FE5FF",
                  },
                  {
                    offset: 1,
                    color: "#1C70C6",
                  },
                ]),
                barBorderRadius: 4,
              },
            },

            data: [],
          },
        ],
      };

      var chartDom = document.getElementById("manufaturingOutPutChart");
      this.chart = this.echarts.init(chartDom);
      this.option && this.chart.setOption(this.option);
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }

        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight;
        if (this.chart) {
          this.chart.getDom().style.height = this.contentHeight;
          this.chart.resize();
        }
      }, 800);
    },
  },
};
</script>
